module.exports = __webpack_public_path__ + "img/explain_rectangle.1ccce741.svg";